export function apiUrl(path: string): string {
  const base = import.meta.env.VITE_API_URL || (import.meta.env.DEV ? 'http://localhost:8787' : '')
  if (!base) {
    throw new Error('VITE_API_URL is required in production')
  }

  return `${base.replace(/\/$/, '')}${path.startsWith('/') ? path : `/${path}`}`
}
